class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initTabs();
  }

  initTabs() {
    const buttons = this.querySelectorAll('[data-tab]');
    const contents = this.querySelectorAll('[tab-id]');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const tabId = button.getAttribute('data-tab').trim();

        // Remove 'is-active' class from all buttons and add to the clicked one
        buttons.forEach(btn => btn.classList.remove('is-active'));
        button.classList.add('is-active');

        // Toggle visibility of contents
        contents.forEach(content => {
          if (content.getAttribute('tab-id').trim() === tabId) {
            content.classList.remove('hidden'); // Show the selected tab
          } else {
            content.classList.add('hidden'); // Hide other tabs
          }
        });
      });
    });
  }
}

customElements.define('product-tabs', ProductTabs);
